import service from 'service';

export const getSubscriptions = ({ queryKey: [, params] }) => {
  const url = `/core_subscription/v1/plans`;
  return service.get(url, { params });
};

export const showSubscription = ({ queryKey: [, id] }) => {
  const url = `/core_subscription/v1/plans/${id}`;
  return service.get(url);
};

export const updateSubscription = ({ uuid, ...payload }) => {
  const url = `/core_subscription/v1/plans/${uuid}`;
  return service.patch(url, payload);
};
